<mat-card class="mat-elevation-z0">
    <mat-card-title class="header">
        <div class="header-title">
            <h3>{{ formElement.text }} <span class="asterisk" *ngIf="formElement.requiredField === 'true'">*</span> <span class="sr-only" *ngIf="isFieldDisabled()">{{ getDisabledReadOnlyAnnouncement() }}</span></h3>
           <span
                *ngIf="formElement.tooltipText != null && formElement.tooltipText !== ''"
                class="material-icons-outlined tooltip-icon"
                [matTooltip]="formElement.tooltipText"
                matTooltipPosition="above">
                help_outline
            </span>
        </div>

        <button
            *ngIf="formElement.disabled !== 'true'"
            mat-flat-button
            class="action-button"
            setColor="primaryColour"
            color="primary"
            appPreventDoubleClick (throttledClick)="showAddModal()"
        >
            <mat-icon aria-hidden="false" class="material-icons-outlined" aria-label="add icon">add</mat-icon>
            <span class="button-text" appLocalizationPopupDirective localizationCode="Add">{{ 'Add' | translate: {Default: "Add"} }}</span>
        </button>
    </mat-card-title>

    <mat-card-content>
        <mat-chip-set aria-label="employee selection">
            <mat-chip *ngFor="let item of items" [ngClass]="{'red-chip': isWorkLocationInactive(item)}">
                {{item?.name}}
                <mat-icon 
                    *ngIf="isWorkLocationInactive(item)"
                    class="error-icon material-icons-outlined"
                    [matTooltip]="translate.instant('InactiveWorkLocationTooltip')" 
                >error_outline</mat-icon>

                <button matChipRemove appPreventDoubleClick (throttledClick)="deleteAllSelected([item])" *ngIf="formElement.disabled !== 'true'">
                    <mat-icon class="material-icons-outlined">cancel</mat-icon>
                </button>
            </mat-chip>
        </mat-chip-set>
    </mat-card-content>
</mat-card>